import React from 'react';
import ReactSVG from 'react-svg';
import iconExcludedAttendant from "../assets/images/icon-excluded-attendant.svg";
import iconEmergency from "../assets/images/icon-emergency.svg";
import iconSegula from "../assets/images/icon-segula.svg";
import iconDryDoorUnlocked from "../assets/images/icon-drydoorunlocked.svg";
import iconDryDoorLocked from "../assets/images/icon-drydoorlocked.svg";
import iconWetDoorUnlocked from "../assets/images/icon-wetdoorunlocked.svg";
import iconWetDoorLocked from "../assets/images/icon-wetdoorlocked.svg";
import iconWetDoorOpen from "../assets/images/icon-wetdooropen.svg";
import iconDryDoorOpen from "../assets/images/icon-drydooropen.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UncontrolledTooltip } from 'reactstrap';
import moment from 'moment';

export default function RoomTile(props) {
  let room = props.room;
  let t = props.t;
  let i18n = props.i18n;

  let allowedMinutes;
  let lastStatusChange;
  let isOverTime;
  let isOverTimeUser;
  let lastSupplyRequest;
  let lastSupplyRequestAgo;
  let lastSupplyRequestIsOverTime;
  let zmanTevilah;
  let sectionMap;
  let activeRoom;
  let roomTypeDisplay;
  if ( props.settings ) {
    let allowedMinutesKey = Object.keys(props.settings).filter(s=>s.toLowerCase()===room.effectiveStatus.toLowerCase()+'minutes').pop();
    allowedMinutes = props.settings[allowedMinutesKey] ? props.settings[allowedMinutesKey].value : null;
    switch (room.effectiveStatus) {
      case 'Prep':
        if (room.reservation.bath) {
          allowedMinutes = parseFloat(props.settings.prepBathMinutes.value);
        } else {
          allowedMinutes = parseFloat(props.settings.prepShowerMinutes.value);
        }
        if (room.reservation.handicapped || room.reservation.kallah) {
          allowedMinutes = parseFloat(props.settings.prepBathMinutes.value);
        }
        if (room.reservation.doubleSlot) {
          allowedMinutes = allowedMinutes + parseFloat(props.settings.prepDoubleSlotExtraMinutes.value);
        }
        break;
      case 'ReadyForMikvahNext':
        allowedMinutes = props.settings.readyForMikvahMinutes.value;
        break;
      case 'ReadyForCheckingNext':
        allowedMinutes = props.settings.readyForCheckingMinutes.value;
        break;
      case 'Done':
        allowedMinutes = 2;
        break;
      default:
        break;
    }

    lastStatusChange = moment.duration(moment(props.time).subtract(props.settings&&props.settings.offset&&props.settings.offset.value,'seconds').diff(room.effectiveStatusLastChange));
    zmanTevilah = props.settings&&props.settings.zmanTevillah&&props.settings.zmanTevillah.value;
    if(room.effectiveStatus==="Prep"){lastStatusChange = moment.duration(moment(props.time).subtract(props.settings&&props.settings.offset&&props.settings.offset.value,'seconds').diff(room.reservation.timePrep));}
    if(!["ReadyForMikvah", "ReadyForMikvahNext", "ReadyForChecking", "ReadyForCheckingNext"].includes(room.effectiveStatus)){
      isOverTimeUser = lastStatusChange.asMinutes()>allowedMinutes;
    } else {
      if(["ReadyForMikvah", "ReadyForMikvahNext"].includes(room.effectiveStatus) && zmanTevilah){
        let lastStatusChangeAfterZman = moment(room.effectiveStatusLastChange).isAfter(zmanTevilah)?lastStatusChange:moment.duration(moment(props.time).subtract(props.settings&&props.settings.offset&&props.settings.offset.value,'seconds').diff(zmanTevilah));
        isOverTime = lastStatusChangeAfterZman.asMinutes()>allowedMinutes;
      } else {
        isOverTime = lastStatusChange.asMinutes()>allowedMinutes;
      }
    }
    if (room.reservation) {
      lastSupplyRequest = room.reservation.supplies.filter(s=>s.status==='open').pop();
      if (lastSupplyRequest) {
        lastSupplyRequestAgo = moment.duration(moment(props.time).subtract(props.settings&&props.settings.offset&&props.settings.offset.value,'seconds').diff(lastSupplyRequest.dateRequested));
        lastSupplyRequestIsOverTime = lastSupplyRequestAgo.asMinutes()>props.settings.waitingForSuppliesMinutes.value;
      }
    }

    if(room.kallah){
      roomTypeDisplay = ["far","gem"];
    }
    if (room.reservation) {
      if (room.reservation.kallah) {
        roomTypeDisplay = ["far","gem"];
      } else if(room.reservation.segula){
        roomTypeDisplay = "segula"; 
      } else if (room.reservation.handicapped) {
        roomTypeDisplay = "wheelchair";
      } else if (room.reservation.bath) {
        roomTypeDisplay = "bath";
      } else {
        roomTypeDisplay = "shower";
      }
    }
  }

  const wetLocksSetting = props.settings && props.settings.accesscontrolWetDoorLocks;
  const dryLocksSetting = props.settings && props.settings.accesscontrolDryDoorLocks;
  const wetTrackSetting = props.settings && props.settings.accesscontrolWetDoorTrackClosed;
  const dryTrackSetting = props.settings && props.settings.accesscontrolDryDoorTrackClosed;

  const requiresAttention = ((room.needsSupplies||room.waitingForAttendant||room.waitingForCall)&&lastSupplyRequestIsOverTime) || (props.settings&&!['Ready', 'Offline', 'NeedsCleaning'].includes(room.effectiveStatus) && (isOverTimeUser||isOverTime));
  return <div className={'room-tile room-tile-room room-tile-' + room.id + ' status-color-' + room.statusColor + ' status-' + room.statusName + (room.section.attendant?'':' no-attendant') + (props.updated?' recentlyUpdatedIn':' recentlyUpdatedOut') + (requiresAttention?' requiresAttention':'')} onClick={props.onClick}>
    <div className="position-relative"><div className="header">
      <div className="number">{room.id}</div>
      <div className="icon">{roomTypeDisplay==='segula'?<ReactSVG className="icon-segula" src={iconSegula} />:<FontAwesomeIcon icon={roomTypeDisplay?roomTypeDisplay:room.roomType}/>}</div>
    </div></div>
      {room.reservation?
        <div className="reservation">
          <div>
            {room.reservation.reservationCode}
            {room.reservation.firstTime?
              <>
                <sup><FontAwesomeIcon className="mis-2 text-orange small" icon="asterisk" id={`icon-new-user-${room.reservation.reservationId}`} /></sup>
                <UncontrolledTooltip target={`icon-new-user-${room.reservation.reservationId}`}>{t("New User")}</UncontrolledTooltip>
              </>
            :null}
            {room.reservation.userPreviousReservationKallah?
              <>
                <sup><FontAwesomeIcon className="mis-2 text-blue" icon="asterisk" id={`icon-previous-kallah-${room.reservation.reservationId}`} /></sup>
                <UncontrolledTooltip target={`icon-previous-kallah-${room.reservation.reservationId}`}>{t("Previous Reservation Kallah")}</UncontrolledTooltip>
              </>
            :null}
            {room.reservation.user.testUser&&<small className="text-muted"> {t("Test")}</small>}
            {(room.reservation.notes||room.reservation.user.notes)&&<FontAwesomeIcon className="icon" icon={["far", "sticky-note"]} />}
            {(room.reservation.user.excludedAttendants && room.reservation.user.excludedAttendants.length>0)&&<ReactSVG className={"icon-excluded" + (room.section.attendant && room.reservation.user.excludedAttendants.filter(att => att.attendantId === room.section.attendant.id).length?" excluded":"")} src={iconExcludedAttendant} alt="Excluded Attendant Icon"/>}
            {room.reservation.attendantInRoom&&<FontAwesomeIcon className="icon" icon={["fas", "female"]} />}
          </div>
          <div className="info-sec mis-1">
            {room.reservation.parking?<FontAwesomeIcon className="icon" icon="car" />:null}
            {room.reservation.doubleSlot||room.reservation.hasExtraTime?<FontAwesomeIcon className="icon" icon={["far", "clock"]} />:null}
            {room.reservation.salonManicure||room.reservation.salonBoth?<FontAwesomeIcon className="icon" icon="paint-brush" />:null}
            {!room.dryDoorLocked && room.effectiveStatus!=="Done" &&
             ((dryTrackSetting && dryTrackSetting.value==='True' && room.dryDoorClosed) || (dryTrackSetting && dryTrackSetting.value==='False'))?<ReactSVG className="lock-icon" src={iconDryDoorUnlocked} />:null}
            {wetLocksSetting && wetLocksSetting.value==='False' && room.wetDoorLocked && room.effectiveStatus=="InMikvah"?<ReactSVG className="lock-icon" src={iconWetDoorLocked} />:null}
            {wetLocksSetting && wetLocksSetting.value==='False' && !room.wetDoorLocked && room.effectiveStatus!=="InMikvah" &&
            ((wetTrackSetting && wetTrackSetting.value==='True' && room.wetDoorClosed) || (wetTrackSetting && wetTrackSetting.value==='False'))?<ReactSVG className="lock-icon" src={iconWetDoorUnlocked} />:null}
            {wetTrackSetting && wetTrackSetting.value==='True' && !room.wetDoorClosed ?<ReactSVG className="lock-icon" src={iconWetDoorOpen} />:null}
            {dryTrackSetting && dryTrackSetting.value==='True' && !room.dryDoorClosed ?<ReactSVG className="lock-icon" src={iconDryDoorOpen} />:null}
          </div>
        </div>
      :
      <div className="d-flex">
        {room.dryDoorLocked?<ReactSVG className="lock-icon" src={iconDryDoorLocked} />:null}
        {wetLocksSetting && wetLocksSetting.value==='False' && !room.wetDoorLocked && 
        ((wetTrackSetting && wetTrackSetting.value==='True' && room.wetDoorClosed) || (wetTrackSetting && wetTrackSetting.value==='False'))?<ReactSVG className="lock-icon" src={iconWetDoorUnlocked} />:null}
        {wetTrackSetting && wetTrackSetting.value==='True' && !room.wetDoorClosed ?<ReactSVG className="lock-icon" src={iconWetDoorOpen} />:null}
        {dryTrackSetting && dryTrackSetting.value==='True' && !room.dryDoorClosed ?<ReactSVG className="lock-icon" src={iconDryDoorOpen} />:null}
      </div>
      }
    <div className="body room-body">
      {room.emergencyCall?
        <ReactSVG className="emergency" src={iconEmergency} />
      :
      <>
      {room.status=="Cleaning" && room.staff?
        <div className="text-center">
          {room.staff.firstName} {room.staff.lastName}
        </div>
      :
      null}
      {room.status=="Checking" && room.reservation && room.reservation.attendant?
        <div className="mie-1">
          {room.reservation.attendant.firstName} {room.reservation.attendant.lastName}
        </div>
      :
      null}
      {props.settings&&(room.needsSupplies||room.waitingForAttendant||room.waitingForCall)?
        <div className={"timer timer-supplies" + (lastSupplyRequestIsOverTime?" over-time-supplies":"")}>
          <FontAwesomeIcon className="icon icon-timer-supplies" icon="hand-paper" /> {parseInt(lastSupplyRequestAgo.asMinutes())}:00
        </div>
      :null}
      {props.settings&&!['Ready', 'Offline', 'NeedsCleaning'].includes(room.effectiveStatus)?
        <>
          <div className={"timer timer-status" + (isOverTimeUser||isOverTime?" over-time":"")}>
            {parseInt(lastStatusChange.asMinutes())}{moment(lastStatusChange.asMilliseconds()).format(':ss')}
          </div>
        </>
      :null}
      </>}
      <div className={"status lang-" + i18n.language}>
        {room.status=='ReadyForChecking'?(room.readyForCheckingPosition!==null?room.readyForCheckingPosition+1:t('Ready'))
        :room.status=='ReadyForMikvah'?(room.readyForMikvahPosition!==null?room.readyForMikvahPosition+1:t('Ready'))
        :room.status=='ReadyForMikvahNext'?1:room.status=='ReadyForCheckingNext'?1:null} {room.status=='ReadyForChecking'||room.status=='ReadyForCheckingNext'?t("For Checking"):room.status=='ReadyForMikvah'||room.status=='ReadyForMikvahNext'?t("For Tevilah")
        :t(room.statusName)} 
      </div>
    </div>
    
  </div>;
}
